import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';
import AccountsContainer from './Accounts/AccountsContainer';
import TransferPage from './Accounts/Transfer/TransferPage';
import OrganizationOverviewRoutes from './OrganizationOverview/Routes';
import { PartnerAccountsProvider } from './providers/PartnerAccounts.provider';
import { ORGANIZATION_OVERVIEW_PATH, TRANSFER_PATH } from './paths';

// The redesigned Accounts pages read their own PartnerAccountsProvider: the app-wide one keeps the
// contract the menu-linked pages were built against.
export default function Routes() {
  const { permissions } = usePermissions();

  return (
    <PartnerAccountsProvider>
      <Switch>
        <ProtectedRoute
          isAllowed={!!permissions.AccountTransfersEnabled}
          showPermission
          exact
          path={TRANSFER_PATH}
          component={TransferPage}
        />

        {/* Same permission as GET /partner/organization; the sub-paths are the Overview's own redirect. */}
        <ProtectedRoute
          isAllowed={!!permissions.accountManagementEnabled}
          showPermission
          path={ORGANIZATION_OVERVIEW_PATH}
          component={OrganizationOverviewRoutes}
        />

        <Route>
          <AccountsContainer />
        </Route>
      </Switch>
    </PartnerAccountsProvider>
  );
}
